module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subscriptionplans/subscriptionplans-list/subscriptionplans-list.component.css
// module id = ./src/app/subscriptionplans/subscriptionplans-list/subscriptionplans-list.component.css
// module chunks = main